import { atom } from 'recoil';
import ClaimRewardsStatuses from '../../components/rewards/common/Constants';

const KEY = 'claimRewardsResultAtom';

export default atom({
  key: KEY,
  default: {
    status: ClaimRewardsStatuses.idle,
    updatedAt: 0,
  },
});
